import { Route } from '@angular/router';
import { AuthGuard } from '@freesixtyfive/auth';
import { _ } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { AdditionalProductDetailComponent } from './pages/catalog/additional-products-page/additional-product-detail/additional-product-detail.component';
import { AdditionalProductsPageComponent } from './pages/catalog/additional-products-page/additional-products-page.component';
import { CategoriesPageComponent } from './pages/catalog/categories-page/categories-page.component';
import { ContingentsPageComponent } from './pages/catalog/contingents-page/contingents-page.component';
import { ContentDetailComponent } from './pages/content/contents-page/content-detail/content-detail.component';
import { ContentsPageComponent } from './pages/content/contents-page/contents-page.component';
import { OpeningHourTypeDetailComponent } from './pages/catalog/opening-hour-types-page/opening-hour-type-detail/opening-hour-type-detail.component';
import { OpeningHourTypesPageComponent } from './pages/catalog/opening-hour-types-page/opening-hour-types-page.component';
import { ProductDetailComponent } from './pages/catalog/products-page/product-detail/product-detail.component';
import { ProductsPageComponent } from './pages/catalog/products-page/products-page.component';
import { ControlPointDetailComponent } from './pages/control-points/control-points-page/control-point-detail/control-point-detail.component';
import { ControlPointsPageComponent } from './pages/control-points/control-points-page/control-points-page.component';
import { QualificationDetailComponent } from './pages/control-points/qualifications-page/qualification-detail/qualification-detail.component';
import { QualificationsPageComponent } from './pages/control-points/qualifications-page/qualifications-page.component';
import { HistoryPageComponent } from './pages/control-points/history-page/history-page.component';
import { StatusPageComponent } from './pages/control-points/status-page/status-page.component';
import { CheckinPageComponent } from './pages/control-points/checkin-page/checkin-page.component';
import { authReturnGuard } from './shared/guards/auth-return.guard';
import { unsavedChangesGuard } from './shared/guards/unsaved-changes.guard';
import { CheckpointsPageComponent } from './pages/checkpoints-page/checkpoints-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { DefectDetailComponent } from './pages/defects-page/defect-detail/defect-detail.component';
import { DefectsPageComponent } from './pages/defects-page/defects-page.component';
import { EyeCatcherPageComponent } from './pages/eye-catcher-page/eye-catcher-page.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ImprintPageComponent } from './pages/imprint-page/imprint-page.component';
import { InspectionsPageComponent } from './pages/inspections-page/inspections-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { RankingPageComponent } from './pages/ranking-page/ranking-page.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { PsaListPageComponent } from './pages/psa-list-page/psa-list-page.component';
import { RoutesPageComponent } from './pages/routes-page/routes-page.component';
import { StartPageComponent } from './pages/start-page/start-page.component';
import { TaskDetailComponent } from './pages/tasks-page/task-detail/task-detail.component';
import { TasksPageComponent } from './pages/tasks-page/tasks-page.component';
import { permissionGuard } from './shared/guards/permission.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full',
  },
  {
    path: 'start',
    title: 'Start',
    component: StartPageComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: [{ label: _('label.start') }] as MenuItem[],
    },
  },
  {
    path: 'login',
    title: 'Login',
    component: LoginPageComponent,
    data: {
      breadcrumbs: [{ label: _('label.login') }] as MenuItem[],
    },
  },
  {
    path: 'forgot-password',
    title: 'Forgot Password',
    component: ForgotPasswordComponent,
    data: {
      breadcrumbs: [{ label: _('label.forgotPassword') }] as MenuItem[],
    },
  },
  {
    path: 'reset-password/:hash',
    title: 'Reset Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: _('label.resetPassword') }] as MenuItem[],
    },
  },
  {
    path: 'change-password',
    title: 'Change Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: _('label.changePassword') }] as MenuItem[],
    },
  },
  {
    path: 'set-password/:hash',
    title: 'Set Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: _('label.setPassword') }] as MenuItem[],
    },
  },
  {
    path: 'imprint',
    title: 'Imprint',
    component: ImprintPageComponent,
    data: {
      breadcrumbs: [{ label: _('label.imprint') }] as MenuItem[],
    },
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    component: DashboardPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'view:dashboard',
      breadcrumbs: [{ label: _('label.dashboard') }] as MenuItem[],
    },
  },
  {
    path: 'eye-catchers',
    title: 'Eye Catchers',
    component: EyeCatcherPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:eyecatchers',
      breadcrumbs: [{ label: _('label.eyeCatchers') }] as MenuItem[],
    },
  },
  {
    path: 'inspections',
    title: 'Inspektionen',
    component: InspectionsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:inspections',
      breadcrumbs: [{ label: _('label.inspections') }] as MenuItem[],
    },
  },
  {
    path: 'catalog/categories',
    title: 'Kategorien',
    component: CategoriesPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        { label: _('catalog.categories.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/contingents',
    title: 'Kontingente',
    component: ContingentsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalogAdmin') },
        { label: _('catalog.contingents.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/additional-products',
    title: 'Zusatzprodukte',
    component: AdditionalProductsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        { label: _('catalog.additionalProducts.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/additional-products/new',
    title: 'Zusatzprodukt anlegen',
    component: AdditionalProductDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.additionalProducts.title'),
          routerLink: '/catalog/additional-products',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/additional-products/:id',
    title: 'Zusatzprodukt bearbeiten',
    component: AdditionalProductDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.additionalProducts.title'),
          routerLink: '/catalog/additional-products',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'content/announcements',
    title: 'Ankündigungen',
    component: ContentsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'contents.manage',
      breadcrumbs: [
        { label: _('label.menuContent') },
        { label: _('content.announcements.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'content/announcements/new',
    title: 'Ankündigung anlegen',
    component: ContentDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'contents.manage',
      breadcrumbs: [
        { label: _('label.menuContent') },
        {
          label: _('content.announcements.title'),
          routerLink: '/content/announcements',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'content/announcements/:id',
    title: 'Ankündigung bearbeiten',
    component: ContentDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'contents.manage',
      breadcrumbs: [
        { label: _('label.menuContent') },
        {
          label: _('content.announcements.title'),
          routerLink: '/content/announcements',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/products',
    title: 'Produkte',
    component: ProductsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        { label: _('catalog.products.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/products/new',
    title: 'Produkt anlegen',
    component: ProductDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.products.title'),
          routerLink: '/catalog/products',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/products/:id',
    title: 'Produkt bearbeiten',
    component: ProductDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.products.title'),
          routerLink: '/catalog/products',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/opening-hour-types',
    title: 'Öffnungszeiten',
    component: OpeningHourTypesPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        { label: _('catalog.openingHourTypes.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/opening-hour-types/new',
    title: 'Öffnungszeit anlegen',
    component: OpeningHourTypeDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.openingHourTypes.title'),
          routerLink: '/catalog/opening-hour-types',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'catalog/opening-hour-types/:id',
    title: 'Öffnungszeit bearbeiten',
    component: OpeningHourTypeDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'catalog.manage',
      breadcrumbs: [
        { label: _('label.menuCatalog') },
        {
          label: _('catalog.openingHourTypes.title'),
          routerLink: '/catalog/opening-hour-types',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/qualifications',
    title: 'Qualifikationen',
    component: QualificationsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        { label: _('controlPoints.qualifications.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/qualifications/new',
    title: 'Qualifikation anlegen',
    component: QualificationDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        {
          label: _('controlPoints.qualifications.title'),
          routerLink: '/control-points/qualifications',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/qualifications/:id',
    title: 'Qualifikation bearbeiten',
    component: QualificationDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        {
          label: _('controlPoints.qualifications.title'),
          routerLink: '/control-points/qualifications',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/control-points',
    title: 'Kontrollpunkte',
    component: ControlPointsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        { label: _('controlPoints.controlPoints.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/control-points/new',
    title: 'Kontrollpunkt anlegen',
    component: ControlPointDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        {
          label: _('controlPoints.controlPoints.title'),
          routerLink: '/control-points/control-points',
        },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/control-points/:id',
    title: 'Kontrollpunkt bearbeiten',
    component: ControlPointDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      permission: 'controlpoints.manage',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        {
          label: _('controlPoints.controlPoints.title'),
          routerLink: '/control-points/control-points',
        },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    // Standalone status + history for admin/inspector who hold
    // controlpoints.view but not kasse.use (so they cannot reach the
    // Tagesdashboard panel). Renders BOTH live status and history.
    path: 'control-points/status',
    title: 'Kontrollpunkte — Status',
    component: StatusPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'controlpoints.view',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        { label: _('controlPoints.overview.title') },
      ] as MenuItem[],
    },
  },
  {
    path: 'control-points/history',
    title: 'Kontrollpunkte — Verlauf',
    component: HistoryPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'controlpoints.view',
      breadcrumbs: [
        { label: _('label.menuControlPoints') },
        { label: _('controlPoints.history.title') },
      ] as MenuItem[],
    },
  },
  {
    // NFC check-in target. Guarded by auth ONLY — the backend
    // controlpoints.checkin permission (CheckinControlPointRequest::authorize)
    // is the security boundary; this thin FE guard is intentional. It preserves
    // the full URL as returnUrl so an expired session resumes the check-in
    // automatically after login (no second tap). NOT permission-gated.
    path: 'control-points/checkin/:tag',
    title: 'Check-in',
    component: CheckinPageComponent,
    canActivate: [authReturnGuard],
    data: {
      breadcrumbs: [{ label: _('controlPoints.checkin.title') }] as MenuItem[],
    },
  },
  {
    path: 'defects',
    title: 'Mängel',
    component: DefectsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:defects',
      breadcrumbs: [{ label: _('label.defects') }] as MenuItem[],
    },
  },
  {
    path: 'defects/new',
    title: 'Mangel erfassen',
    component: DefectDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:defects',
      breadcrumbs: [
        { label: _('label.defects'), routerLink: '/defects' },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'defects/:id',
    title: 'Mangel bearbeiten',
    component: DefectDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:defects',
      breadcrumbs: [
        { label: _('label.defects'), routerLink: '/defects' },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'tasks',
    title: 'Aufgaben',
    component: TasksPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:tasks',
      breadcrumbs: [{ label: _('label.tasks') }] as MenuItem[],
    },
  },
  {
    path: 'tasks/new',
    title: 'Aufgabe anlegen',
    component: TaskDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:tasks',
      breadcrumbs: [
        { label: _('label.tasks'), routerLink: '/tasks' },
        { label: _('label.new') },
      ] as MenuItem[],
    },
  },
  {
    path: 'tasks/:id',
    title: 'Aufgabe bearbeiten',
    component: TaskDetailComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'manage:tasks',
      breadcrumbs: [
        { label: _('label.tasks'), routerLink: '/tasks' },
        { label: _('label.edit') },
      ] as MenuItem[],
    },
  },
  {
    path: 'psas',
    title: 'PSA / Gurte',
    component: PsaListPageComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: [{ label: _('label.psas') }] as MenuItem[],
    },
  },
  {
    path: 'routes',
    title: 'Routen',
    component: RoutesPageComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: [{ label: 'Routen' }] as MenuItem[],
    },
  },
  {
    path: 'checkpoints',
    title: 'Checkpoints',
    component: CheckpointsPageComponent,
    canActivate: [AuthGuard, permissionGuard],
    data: {
      permission: 'view:checkpointTracking',
      breadcrumbs: [{ label: _('label.checkpoints') }] as MenuItem[],
    },
  },
  {
    path: 'ranking',
    title: 'Ranking',
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: RankingPageComponent,
        data: {
          mode: 'default',
          breadcrumbs: [{ label: _('label.rankings') }] as MenuItem[],
        },
      },
      {
        path: 'screen',
        component: RankingPageComponent,
        data: {
          mode: 'screen',
          breadcrumbs: [{ label: _('label.rankings') }] as MenuItem[],
        },
      },
      {
        path: 'user/:nickname',
        component: RankingPageComponent,
        data: {
          mode: 'user',
          breadcrumbs: [{ label: _('label.rankings') }] as MenuItem[],
        },
      },
    ],
  },
  {
    path: 'users',
    title: 'Users',
    canActivate: [AuthGuard, permissionGuard],
    loadComponent: () =>
      import('./pages/users-page/users-page.component').then(
        (c) => c.UsersPageComponent,
      ),
    data: {
      permission: 'manage:users',
      breadcrumbs: [{ label: _('label.editUsers') }] as MenuItem[],
    },
  },
  {
    path: 'buchungen',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/bookings/bookings.routes').then((m) => m.bookingsRoutes),
  },
  {
    // Public storefront (R1) — deliberately without a guard, and deliberately
    // declared ABOVE the catch-all below, which would otherwise bounce every
    // shop URL to the login page.
    path: 'shop',
    loadChildren: () =>
      import('./pages/shop/shop.routes').then((m) => m.shopRoutes),
  },
  {
    path: '**',
    title: 'Login',
    redirectTo: '/login',
  },
];
